import type { Topic, TopicReasonTip } from '../types/api'

export const REASON_CATEGORY_LABELS: Record<TopicReasonTip['category'], string> = {
  audience_interest: '观众反馈',
  channel_alignment: '频道匹配',
  prediction_signals: '站内趋势',
  other: '其他依据',
}

export const TOPIC_EVIDENCE_TAGS: Record<TopicReasonTip['category'], string> = {
  audience_interest: '用户诉求',
  channel_alignment: '账号表现',
  prediction_signals: '站内趋势',
  other: '其他依据',
}

export const TOPIC_TIP_SCORE_GATE = 70

const compact = (value: string, max: number) => {
  const text = value.trim().replace(/\s+/g, ' ')
  return text.length > max ? `${text.slice(0, max)}…` : text
}

export function topicReasonTips(topic: Topic): TopicReasonTip[] {
  const modelTips = (topic.reason_tips || [])
    .filter(item => {
      const score = topic.scores?.[item.category]
      return Boolean(item && REASON_CATEGORY_LABELS[item.category] && item.text?.trim() && typeof score === 'number' && score >= TOPIC_TIP_SCORE_GATE)
    })
    .sort((left, right) => (topic.scores?.[right.category] || 0) - (topic.scores?.[left.category] || 0))
    .slice(0, 3)
    .map(item => ({
      category: item.category,
      label: compact(item.label || REASON_CATEGORY_LABELS[item.category], 10),
      text: compact(item.text || '', 120),
    }))
  return modelTips
}

export function topicEvidenceTags(topic: Topic): string[] {
  return topicReasonTips(topic).map(item => TOPIC_EVIDENCE_TAGS[item.category])
}
